<td class="sticky-col first-col tableBg" style="z-index: 100; width: 64px"
    *ngIf="inTable && !inline && (discussionService.showRibbon || discussionService.showDiscussionSideBar)">
  <span *ngIf="!discussionService.loading"
        (click)="hasDiscussion ? selectDiscussableGroup() : createNewTopic()"
        class="bg-discussion"
        [ngClass]="{'active' : discussionService?.selectedGroup?.element?.id === _entityElement?.element?.id, 'ribbon-inline': inTable}">
    <sb-icon *ngIf="hasDiscussion" [icon]="'discussionsFilled'"></sb-icon>
    <sb-icon *ngIf="!hasDiscussion" [icon]="'discussions'"></sb-icon>
  </span>
</td>
<ng-container *ngIf="inline && (discussionService.showRibbon || discussionService.showDiscussionSideBar)">
  <span *ngIf="!discussionService.loading"
        (click)="hasDiscussion ? selectDiscussableGroup() : createNewTopic()"
        class="bg-discussion"
        [ngClass]="{'active' : discussionService?.selectedGroup?.element?.id === _entityElement?.element?.id, 'ribbon-inline': inline}">
    <sb-icon *ngIf="hasDiscussion" [icon]="'discussionsFilled'"></sb-icon>
    <sb-icon *ngIf="!hasDiscussion" [icon]="'discussions'"></sb-icon>
</span>
</ng-container>
<div *ngIf="!inTable && !inline" class="invisible-dom" style="z-index: 100">
    <span
      *ngIf="!discussionService.loading && (discussionService.showRibbon || discussionService.showDiscussionSideBar)"
      (click)="hasDiscussion ? selectDiscussableGroup() : createNewTopic()"
      class="bg-discussion"
      [ngClass]="{'active' : discussionService?.selectedGroup?.element?.id === _entityElement?.element?.id, 'ribbon' : !inTable}">
    <sb-icon *ngIf="hasDiscussion" [icon]="'discussionsFilled'"></sb-icon>
    <sb-icon *ngIf="!hasDiscussion" [icon]="'discussions'"></sb-icon>
  </span>
</div>

<ng-content></ng-content>
